import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import VideoCard from '@/components/feature/VideoCard';
import { JsonLd, getOrganizationSchema, getWebSiteSchema, getWebPageSchema } from '@/components/feature/JsonLd';
import { videos, categories } from '@/mocks/videos';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');

  const hotVideos = videos.filter((v) => v.isHot);
  const newVideos = videos.filter((v) => v.isNew);
  const filteredVideos = activeCategory === 'all'
    ? videos
    : videos.filter((v) => v.categorySlug === activeCategory);

  return (
    <>
      <JsonLd data={getOrganizationSchema()} />
      <JsonLd data={getWebSiteSchema()} />
      <JsonLd data={getWebPageSchema(
        '桃花视频 - 91视频网站久久视频在线观看 | 91在线视频免费高清全集不缓冲',
        '桃花视频提供91视频、91视频网站、久久视频、91在线视频等热门影视资源，免费在线观看高清电视剧全集和电影大全，流畅不缓冲。',
        '/'
      )} />

      <Header />

      <main>
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="首页英雄区">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20atmospheric%20cinema%20theater%20interior%20with%20warm%20golden%20stage%20lights%20and%20velvet%20curtains%2C%20dramatic%20cinematic%20lighting%2C%20elegant%20movie%20premiere%20atmosphere%2C%20deep%20rich%20colors%2C%20luxurious%20entertainment%20venue%2C%20professional%20photography&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
            alt="桃花视频 - 高清影视在线观看"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl">
                <p className="text-accent-400 text-sm md:text-base font-medium mb-3 tracking-widest uppercase">
                  桃花盛开处 精彩永不断
                </p>
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
                  海量高清影视
                  <br />
                  <span className="text-accent-400">免费在线观看</span>
                </h1>
                <p className="text-white/70 text-sm md:text-lg mb-8 max-w-xl leading-relaxed">
                  汇聚10万+影视资源，涵盖电影、电视剧、综艺、动漫、纪录片。91视频、久久视频、91在线视频高清全集，流畅不缓冲，随时随地享受极致观影体验。
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                  <Link
                    to="/category/hot"
                    className="px-7 py-3 text-sm font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-fire-line mr-2"></i>
                    热门推荐
                  </Link>
                  <Link
                    to="/category/movie"
                    className="px-7 py-3 text-sm font-semibold rounded-full bg-white/15 text-white border border-white/30 hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
                  >
                    <i className="ri-film-line mr-2"></i>
                    最新电影
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute bottom-6 left-4 md:left-6 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span className="w-2 h-2 rounded-full bg-white/40"></span>
            <span className="w-2 h-2 rounded-full bg-white/40"></span>
            <span className="w-2 h-2 rounded-full bg-white/40"></span>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-50" aria-label="视频分类导航">
          <div className="flex items-center gap-1 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveCategory(cat.slug)}
                className={`shrink-0 px-5 py-2.5 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </button>
            ))}
          </div>
        </section>

        <section className="w-full px-4 md:px-6 pb-8 md:pb-12 bg-background-50" aria-label="视频列表">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
            {filteredVideos.slice(0, 10).map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
          {filteredVideos.length > 10 && (
            <div className="text-center mt-8">
              <Link
                to={`/category/${activeCategory}`}
                className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium rounded-full bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors duration-200 cursor-pointer"
              >
                查看更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          )}
        </section>

        {hotVideos.length > 0 && (
          <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-100" aria-label="热门推荐">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  <i className="ri-fire-fill text-accent-500 mr-2"></i>
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">全网最热影视，大家都在看</p>
              </div>
              <Link
                to="/category/hot"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
              {hotVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </section>
        )}

        {newVideos.length > 0 && (
          <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-50" aria-label="最新上线">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  <i className="ri-sparkling-line text-primary-500 mr-2"></i>
                  最新上线
                </h2>
                <p className="text-sm text-foreground-500 mt-1">新鲜出炉，第一时间尝鲜</p>
              </div>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
              {newVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </section>
        )}

        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-100" aria-label="按分类浏览">
          <div className="mb-6 md:mb-8">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
              按分类浏览
            </h2>
            <p className="text-sm text-foreground-500 mt-1">探索不同类型的精彩内容</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {categories.slice(1).map((cat) => {
              const catVideos = videos.filter((v) => v.categorySlug === cat.slug);
              const previewVideos = catVideos.slice(0, 3);
              return (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group block bg-background-50 rounded-lg p-4 md:p-5 hover:bg-background-200 transition-colors duration-200 cursor-pointer"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                      <i className={`${cat.icon} text-lg`}></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900">{cat.name}</h3>
                      <p className="text-xs text-foreground-500">{catVideos.length} 部作品</p>
                    </div>
                  </div>
                  {previewVideos.length > 0 && (
                    <div className="flex gap-1.5">
                      {previewVideos.map((v) => (
                        <div key={v.id} className="flex-1 aspect-video rounded overflow-hidden bg-background-200">
                          <img
                            src={v.thumbnail}
                            alt={v.title}
                            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            loading="lazy"
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </Link>
              );
            })}
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-50" aria-label="观看数据">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            <div className="text-center p-6 rounded-lg bg-background-100">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-user-heart-line text-xl text-accent-500"></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-1">5000万+</div>
              <div className="text-sm text-foreground-500">累计用户</div>
            </div>
            <div className="text-center p-6 rounded-lg bg-background-100">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-film-line text-xl text-primary-500"></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-1">10万+</div>
              <div className="text-sm text-foreground-500">影视资源</div>
            </div>
            <div className="text-center p-6 rounded-lg bg-background-100">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-play-circle-line text-xl text-primary-500"></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-1">3000万+</div>
              <div className="text-sm text-foreground-500">日均播放</div>
            </div>
            <div className="text-center p-6 rounded-lg bg-background-100">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-shield-check-line text-xl text-accent-500"></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-1">正版授权</div>
              <div className="text-sm text-foreground-500">安全观影</div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}